import { Modal } from "@mui/material";
import styles from "./ActiveConnection.module.css";
import ongoingImage from "../../../../assets/images/ongoing.svg";
import { useLocation, useNavigate } from "react-router-dom";

const ActiveConnection = ({ open, onClose }) => {
  const navigate = useNavigate();
  let location = useLocation();
  let listingId = location?.search?.split("=")[1];

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.modal}>
        <div className={styles.emptyState}>
          <img
            style={{ marginBottom: "10px" }}
            src={ongoingImage}
            alt="No Available Listings"
          />
          <h2>Connection Moved to Active Connections </h2>

          <p>
            You’ve successfully accepted the connection request and the
            connection has been moved to
            <span style={{ color: "var(--primary-color-text)" }}> Active </span>
            Connections. Please proceed to finalize the terms and conditions.{" "}
          </p>

          <div>
            <div
              className={styles.addListingButton}
              onClick={() => {
                navigate(`/bilateral?id=${listingId}`);
              }}
            >
              <span>Go to Active Connections</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ActiveConnection;
